export default "__VITE_ASSET__DePW9gF0__"